import { useParams } from 'react-router-dom';

import useMission from '@/hooks/useMission';

export default function useQuest() {
  const { questId } = useParams<AppParam>();
  const { missions, mission, mutate } = useMission();

  const allQuests =
    missions &&
    missions.flatMap((currentMission) =>
      Array.isArray(currentMission.quests) ? currentMission.quests : []
    );
  const quests = mission && Array.isArray(mission.quests) ? mission.quests : undefined;
  const questIndex = questId ? quests?.findIndex((quest) => quest.id.toString() === questId) : -1;
  const quest =
    quests && typeof questIndex === 'number' && questIndex >= 0 ? quests[questIndex] : undefined;

  return { allQuests, quests, quest, questIndex, mutate };
}
